// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Canadian English translations bundled for immediate availability
const caEnTranslations = {
  home: {
    hero: {
      heading: "adgro",
      tagline: "Effortlessly Generate Grocery Flyers Directly From Your Point-of-Sale System",
      description: "From ad creation to ad distribution, adgro uses automation and partner integrations to help you merchandize promotions effectively, adapt to changing inventory position in real-time, and maximize profitability."
    },
    reasons: {
      heading: "Why Choose Us",
      "description-1": "Generate beautiful, engaging, and effective ",
      product: "digital grocery flyers ",
      "description-2": "that drive customer traffic to your stores."
    },
    "reason-1": {
      "number-text": "01",
      heading: "Ready-to-use Product Catalog",
      description: "Over 1 million products with clean titles and images automatically matched with your catalog"
    },
    "reason-2": {
      "number-text": "02",
      heading: "Out-of-the-box POS Integrations",
      description: "NCR, Square, Lightspeed, Clover, ePOS, and many more to pull live pricing, promotions, and inventory data"
    },
    "reason-3": {
      "number-text": "03",
      heading: "Automated Ad Creation",
      description: "Opt-in for the platform to auto-generate flyers based on changing promotions and inventory. Daily not weekly"
    },
    "reason-4": {
      "number-text": "04",
      heading: "Integrated Distribution",
      description: "One-click publish to free and paid channels with advanced targeting capabilities to reach customers in your neighbourhood"
    },
    pricing: {
      heading: "Our Pricing",
      description: "Our prices are much lower compared to using a creative agency",
      currency: "$",
      "basic-plan": {
        price: "100",
        per: "/",
        unit: "mo",
        title: "Basic Plan",
        "no-of-locations": "1 Store Location",
        "no-of-ads": "1 Flyer Ad",
        "frequency-of-updates": "Manual Pricing and Inventory Updates",
        distribution: "Download PDF and High Res Image for Distribution"
      },
      "standard-plan": {
        price: "150",
        per: "/",
        unit: "mo",
        title: "Standard Plan",
        "no-of-locations": "1 Store Location",
        "no-of-ads": "Unlimited Flyers",
        "frequency-of-updates": "Automated Pricing and Inventory Updates from POS",
        distribution: "Automated Distribution on Website and Facebook & Instagram",
        "hours-of-support": "24/7 Support"
      },
      "premium-plan": {
        price: "200",
        per: "/",
        unit: "mo",
        title: "Premium Plan",
        "no-of-locations": "1 Store Location",
        "no-of-ads": "Unlimited Flyers",
        "frequency-of-updates": "Automated Pricing and Inventory Updates from POS",
        distribution: "Automated Distribution on Website and Facebook & Instagram",
        "paid-ads": "Automated Distribution via Facebook and Google Ads",
        "ai-concierge": "AI Concierge Agent",
        "hours-of-support": "24/7 Support"
      }
    }
  },
  header: {
    nav: {
      home: "Home",
      dashboard: "Dashboard",
      pricing: "Pricing",
      contact: "Contact Us",
      about: "About",
      features: "Features",
      country: "Country: ",
      welcome: "Welcome, ",
      "log-in": "Log In",
      "log-out": "Log Out",
      "sign-up": "Get Early Access"
    }
  },
  hero: {
    badge: "AI-Powered Marketing Automation",
    "sign-up-today": "Sign Up Today",
    "watch-demo": "Watch Demo",
    "get-started": "Get Started",
    "most-popular": "Most Popular"
  },
  "footer-links": {
    "quick-links": "Quick Links",
    legal: "Legal",
    description: "AI-powered marketing automation for grocery stores. Generate beautiful flyers directly from your POS system."
  },
  footer: {
    about: "About",
    terms: "Terms of Use",
    privacy: "Privacy Policy",
    copyright: "© 2026 Rhombus Labs Inc. All Rights Reserved."
  },
  welcome: {
    "sign-up-form": {
      heading: "We're thrilled to have you on board!",
      "body-copy": "By signing up for our Early Access, you'll gain exclusive access to our platform in its development phase. Your feedback and insights will play a crucial role in shaping the final product, and we can't wait to hear your thoughts."
    }
  },
  dashboard: {
    heading: "Dashboard",
    "body-copy": "Thank you for signing up for Early Access. We are heads down in development. Member of our team will be reaching out to set you up."
  },
  "dashboard-nav": {
    "main-nav": {
      dashboard: "Dashboard",
      "product-catalog": "Product Catalog",
      flyers: "Flyers",
      distribution: "Distribution",
      analytics: "Analytics & Insights",
      invite: "+ Invite Team Members",
      settings: "Settings",
      account: "Account & Billing",
      logout: "Logout",
      "back-to": "Back to Dashboard"
    },
    "products-nav": {
      overview: "Products Catalog",
      new: "+ New Product",
      scan: "Scan Product",
      upload: "Bulk Upload"
    },
    "flyers-nav": {
      overview: "Flyers",
      "new-flyer": "+ New Flyer",
      "flyer-templates": "Flyer Templates",
      "new-flyer-template": "+ New Flyer Template",
      "ad-templates": "Ad Templates",
      "new-ad-template": "+ Ad Template"
    }
  }
};

// Initialize i18n synchronously with bundled translations
// Using Canadian English as the default (en-CA)
i18n
  .use(initReactI18next)
  .init({
    lng: "en-CA",
    fallbackLng: "en-CA",
    initImmediate: false, // Initialize synchronously
    interpolation: {
      escapeValue: false
    },
    resources: {
      'en-CA': {
        translation: caEnTranslations
      }
    },
    react: {
      useSuspense: false
    }
  });

// Log to confirm initialization
console.log('[i18n] Initialized with language:', i18n.language);
console.log('[i18n] Test translation:', i18n.t('header.nav.home'));

export default i18n;